import { FileExtension } from "@inrev/common";
import { lookup, mimes } from "mrmime";

export const getMimeTypes = (allowedExtensions?: FileExtension[]) => {
	if (!allowedExtensions) {
		allowedExtensions = Object.values(FileExtension);
	}
	const formattedFileExtensions = Object.values(FileExtension).map((ext) => `.${ext}`);
	const mimeMap: Record<string, string[]> = {};

	(allowedExtensions ?? formattedFileExtensions).forEach((extension) => {
		const mime = lookup(extension);
		if (!mime) throw new Error(`mime not found for extension ${extension}`);
		if (!mimeMap[mime]) mimeMap[mime] = [`.${extension}`];
		else mimeMap[mime].push(`.${extension}`);
	});

	return mimeMap;
};

export function initializeMimeTypes() {
	mimes[".docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
	mimes["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
	mimes[".docm"] = "application/vnd.ms-word.document.macroenabled.12";
	mimes["docm"] = "application/vnd.ms-word.document.macroenabled.12";
	mimes[".xls"] = "application/vnd.ms-excel";
	mimes["xls"] = "application/vnd.ms-excel";
	mimes[".xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
	mimes["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
	mimes[".xlsm"] = "application/vnd.ms-excel.sheet.macroenabled.12";
	mimes["xlsm"] = "application/vnd.ms-excel.sheet.macroenabled.12";
	mimes[".xlsb"] = "application/vnd.ms-excel.sheet.binary.macroenabled.12";
	mimes["xlsb"] = "application/vnd.ms-excel.sheet.binary.macroenabled.12";
	mimes["xlam"] = "application/vnd.ms-excel.addin.macroenabled.12";
	mimes[".xlam"] = "application/vnd.ms-excel.addin.macroenabled.12";
	mimes["xla"] = "application/vnd.ms-excel";
	mimes[".xla"] = "application/vnd.ms-excel";
	mimes["pptx"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
	mimes[".pptx"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
	mimes["pptm"] = "application/vnd.ms-powerpoint.presentation.macroenabled.12";
	mimes[".pptm"] = "application/vnd.ms-powerpoint.presentation.macroenabled.12";
	mimes["ppsx"] = "application/vnd.openxmlformats-officedocument.presentationml.slideshow";
	mimes[".ppsx"] = "application/vnd.openxmlformats-officedocument.presentationml.slideshow";
	mimes["ppsm"] = "application/vnd.ms-powerpoint.slideshow.macroenabled.12";
	mimes[".ppsm"] = "application/vnd.ms-powerpoint.slideshow.macroenabled.12";
	mimes["ppt"] = "application/vnd.ms-powerpoint";
	mimes[".ppt"] = "application/vnd.ms-powerpoint";
	mimes["pps"] = "application/vnd.ms-powerpoint";
	mimes[".pps"] = "application/vnd.ms-powerpoint";
	mimes["msg"] = "application/vnd.ms-outlook";
	mimes[".msg"] = "application/vnd.ms-outlook";
	mimes["eml"] = "message/rfc822";
	mimes[".eml"] = "message/rfc822";
}
